import { Grid, TextInput, Select, Typography } from '@ts/storybook';
import { ColorPicker } from '@components/Inputs';
import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';

import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { CLabel, IForm } from '@ts/ui-models';

interface ILabelFormProps extends IForm {
  values: CLabel;
}

const LabelForm = (props: ILabelFormProps) => {
  const { values, mode, requiredFields, onChange, onCallbackChange } = props;
  const { name, color, notes, restrictedToEntities } = values;

  const isViewMode = mode === 'view';

  const restrictionOptions = () => [
    {
      label: 'Items',
      value: 'tsElement',
    },
    {
      label: 'Users',
      value: 'taUser',
    },
    {
      label: 'Events',
      value: 'taEvent',
    },
  ];

  //#region Handlers

  const handleChangeItemType = value => {
    onChange('itemTypeIds', value);
    onChange('restrictedToEntities', 'tsElement');
  };
  const handleChangeEntity = entity => {
    onChange('restrictedToEntities', entity);
    if (entity && entity != 'tsElement') onChange('itemTypeIds', null);
  };
  const onChangeColor = color => {
    const { data: data0 } = props.values;
    const newData = { ...data0, color: color };

    onChange('data', newData);
  };
  //#endregion

  //#region Render
  const renderRestrictions = () => {
    const { values } = props;
    const { itemTypeIds } = values;

    const disableItemType = isViewMode || !restrictedToEntities || restrictedToEntities != 'tsElement';
    const showItemTypes = restrictedToEntities && restrictedToEntities == 'tsElement';
    return (
      <Grid container mt={2}>
        <Typography variant={'h6'} text="Restricted to" />
        <Select
          isReadOnly={isViewMode}
          label={'Entity'}
          value={restrictedToEntities}
          onChange={handleChangeEntity}
          options={restrictionOptions()}
        />
        {showItemTypes && (
          <WrapperEntitySelector
            label={'Item types'}
            searchComponent={generateSearchEntitySelector('itemType')}
            value={itemTypeIds}
            onChange={handleChangeItemType}
            isReadOnly={disableItemType}
            multiple
          />
        )}
      </Grid>
    );
  };

  return (
    <Grid container spacing={2} columnSpacing={6}>
      <Grid container size={6}>
        <Grid size={12}>
          <TextInput
            isReadOnly={isViewMode}
            label="Name"
            value={name}
            onChangeValue={onCallbackChange('name')}
            required={requiredFields.includes('name')}
            infoText="Blank spaces at the beggining and the end will be trimmed on save"
          />
        </Grid>
        {((notes && isViewMode) || !isViewMode) && (
          <Grid size={12}>
            <TextInput isReadOnly={isViewMode} label="Notes" value={notes} onChangeValue={onCallbackChange('notes')} multiline />
          </Grid>
        )}
        {((restrictedToEntities && isViewMode) || !isViewMode) && <Grid size={12}>{renderRestrictions()}</Grid>}
      </Grid>
      <Grid container size={6} direction="column">
        <Typography variant="h6" text="Color" />
        <ColorPicker isOnlyOne isReadOnly={isViewMode} value={color || '#000000'} onChange={onChangeColor} />
      </Grid>
    </Grid>
  );
};

export default LabelForm;
